export default {
  API_ENDPOINT: "https://pacific-lake-42207.herokuapp.com/",
  TOKEN_KEY: 'blogful-client-auth-token',
}
